import TooltipWrapper from "views/uikit/TooltipWrapper";
import { BiInfoCircle } from "react-icons/bi";
import { ReactNode } from "react";

import styles from "./styles.module.scss";

const QUERY_TITLE_TOOLTIP_ID = "query-title-tooltip";

interface QueryModalTitleProps {
  info?: string;
  icon: ReactNode;
  children: ReactNode;
}

export default function QueryModalTitle({
  icon,
  info,
  children,
}: QueryModalTitleProps) {
  return (
    <div className={styles.queryModalTitle}>
      <div className={styles.icon} data-testid="query-modal-title-icon">
        {icon}
      </div>
      <span className={styles.queryModalTitleContainer}>{children}</span>
      {info && (
        <span
          className={styles.info}
          data-tooltip-content={info}
          data-tooltip-id={QUERY_TITLE_TOOLTIP_ID}
        >
          <BiInfoCircle />
          <TooltipWrapper id={QUERY_TITLE_TOOLTIP_ID} maxWidth="320px" />
        </span>
      )}
    </div>
  );
}
